import React, { useState, useEffect } from "react";
import { projectService } from "../../../services/projectService";
import {
  MainContainer,
  BackgroundPattern,
  ContentWrapper,
  HeaderSection,
  Title,
  Subtitle,
  StyledTable,
  PaginationContainer,
  PageButton,
} from "./styles";

const ProjectTokensAnnualVisionList = ({ project_id }) => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(12);

  useEffect(() => {
    fetchData();
  }, [currentPage, itemsPerPage]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const token = sessionStorage.getItem("Authorization");

      const startYear = 2020;
      const endYear = 2028;
      const yearRange = Array.from(
        { length: endYear - startYear + 1 },
        (_, index) => startYear + index
      );

      const requestData = { years: yearRange };

      // 🔹 Chamada centralizada via service
      const responseData = await projectService.getProjectTokensByYears(requestData, token);

      setItems(responseData);
    } catch (error) {
      console.error("❌ Erro ao buscar tokens por ano:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(items.length / itemsPerPage); i++) {
    pages.push(i);
  }

  return (
    <MainContainer>
      <BackgroundPattern />
      <ContentWrapper>
        <HeaderSection>
          <Title>Tokens Visão Anual</Title>
          <Subtitle>Distribuição anual de tokens por status</Subtitle>
        </HeaderSection>

        <StyledTable>
          <thead>
            <tr>
              <th>Ano</th>
              <th>Ativos</th>
              <th>Aposentados</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="3">Carregando...</td>
              </tr>
            ) : (
              items
                .slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )
                .map((item, index) => (
                  <tr key={`${item.name}-${index}`}>
                    <td>{item.name}</td>
                    <td>{item.ativos}</td>
                    <td>{item.aposentados}</td>
                  </tr>
                ))
            )}
          </tbody>
        </StyledTable>

        <PaginationContainer>
          <span>Página:</span>
          {pages.map((page) => (
            <PageButton
              key={page}
              onClick={() => handlePageChange(page)}
              disabled={page === currentPage}
            >
              {page}
            </PageButton>
          ))}
        </PaginationContainer>
      </ContentWrapper>
    </MainContainer>
  );
};

export default ProjectTokensAnnualVisionList;
